// From https://github.com/sooro-io/react-gtm-module/blob/main/src/Snippets.js
import {DataLayer, GtmProps, Snippets} from './Snippet.ts';
import {config} from '../../config.ts';

export const TagManager = {
    isConfigured: function (): boolean {
        return Boolean(config.sstUrl && config.gtmLoaderPath);
    },
    dataScript: function (
        dataLayer: string,
        dataLayerName: string | undefined = 'dataLayer',
    ): HTMLScriptElement {
        const script = document.createElement('script');
        script.innerHTML = dataLayer;
        script.setAttribute('data-testid', dataLayerName!);
        if (config.nonce) {
            script.setAttribute('nonce', config.nonce);
        }
        return script;
    },
    gtm: function (args: GtmProps) {
        const snippets = Snippets.tags(args);

        const script = () => {
            const script = document.createElement('script');
            script.innerHTML = snippets.script;
            if (config.nonce) {
                script.setAttribute('nonce', config.nonce);
            }
            return script;
        };

        const dataScript = this.dataScript(
            snippets.dataLayerVar,
            args.dataLayerName,
        );

        return {
            script,
            dataScript,
        };
    },
    initialize: function ({
        source,
        events = [],
        dataLayer,
        dataLayerName = 'dataLayer',
        auth,
        preview,
    }: GtmProps) {
        const gtm = this.gtm({
            events,
            dataLayer,
            dataLayerName,
            auth,
            preview,
            source,
        });
        if (dataLayer) document.head.appendChild(gtm.dataScript);
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    },
    dataLayer: function ({
        dataLayer,
        dataLayerName = 'dataLayer',
    }: {
        dataLayer: DataLayer;
        dataLayerName?: string;
    }) {
        if (window[dataLayerName]) return window[dataLayerName].push(dataLayer);
        const snippets = Snippets.dataLayer(dataLayer, dataLayerName);
        const dataScript = this.dataScript(snippets, dataLayerName);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    },
};
